import { FunctionComponent, useEffect,useState } from "react";
import { RouteComponentProps, useParams, withRouter } from "react-router-dom";
import { Guid} from "../../../api/baseApi";
import GlobalSpinner from "../../components/globalsSpinner/GlobalSpinner";
import InnerLayout from "../innerLayout/InnerLayout";
import { FormInput, FormRow } from "../../components/formRow/FormRow";
import { getPastDateByDaysAgo, isFirstDateGreaterThanSecond } from "../../../services/dateService";
import FormCheckbox from "../../components/formRow/FormCheckbox";
import { AllDaysStatistic, getDaysStatistic} from "../../../api/channelsApi";
import { formatDurationLong, formatToPercent } from "../../../services/common";
import Select, { MultiValue } from "react-select";
import { getTags } from "../../../api/tagApi";
import { Button } from "../../components/Button";
import HistoricViewBlock from "../../components/historicVIew/HistoricView";
import { Area, AreaChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, TooltipProps, XAxis, YAxis } from "recharts";


interface  ChannelPlaylistParams{
    channelId: Guid,
    nestedPlayListsId: Guid
}

interface ChannelPlaylistProps extends RouteComponentProps<any>{
    logOut : () => void;
    toogleCollapse: () => void;
    isCollapsed: boolean;
}

type Option<T> = { value: T, label: string}

type ChartDataRow = {
    date:string, 
    campaign: number, 
    inhouseContent: number, 
    siteContent: number, 
    other: number
}
 
const ChannelPlaylist: FunctionComponent<ChannelPlaylistProps> = (props: ChannelPlaylistProps) => {
    let {isCollapsed, logOut, toogleCollapse } = props;

    let [isLoading, setIsLoading] = useState<boolean>(false);
    
    let [selectedStartDate, setSelectedStartDate] = useState<string>(getPastDateByDaysAgo(7))
    let [isSelectedStartDateError, setIsSelectedStartDateError] = useState(false)
    let [selectedEndDate, setSelectedEndDate] = useState<string>(getPastDateByDaysAgo(0))
    let [isSelectedEndDateError, setIsSelectedEndDateError] = useState(false)
    let [selectedTime, setSelectedTime] = useState<string>("00:00")

    let [tags,setTags] = useState<Option<Guid>[]>([]);
    let [selectedTagIds, setSelectedTagIds] = useState<Guid[]>([]);

    let [isLiveToggle, setIsLiveToggle] = useState(false);

    let [statistic, setStatistic] = useState<AllDaysStatistic>()

    let [chartData, setChartData] = useState<ChartDataRow[]>([])

    let { channelId, nestedPlayListsId } = useParams<ChannelPlaylistParams>();
    
    useEffect(() => {
        async function fetchData(){
            setIsLoading(true);
            await Promise.all([
                updateList(), 
                updateTags(),
            ]);

            setIsLoading(false);
        }
        fetchData();
    }, [])

    useEffect(() => {
        validateReportPeriodDates(selectedStartDate,selectedEndDate)
    }, [selectedEndDate,selectedStartDate])

    const updateList = async () => {
        let request = {
            startDateString: selectedStartDate,
            endDateString: selectedEndDate,
            hour: selectedTime.split(":")[0],
            isLive: isLiveToggle,
            tagIds: selectedTagIds
        }

        let response = await getDaysStatistic(channelId, nestedPlayListsId, request);
        if( response.type === "succes") {
            setStatistic(response.data.data)
            setChartData(convertToChartData(response.data.data))
        }
    }

    const updateTags = async () => {
        let tagResponse = await getTags();
        if(tagResponse.type == "succes") {
            setTags([
                {
                    label: "No Tags",
                    value: "00000000-0000-0000-0000-000000000000"
                },
                ...tagResponse.data.items.map( t => { return {label:t.name, value:t.id}})
            ])
        }
    }   
    
    const convertChartDate = (dateString: string) => {
        let [date, time] = dateString.split("T")
        return `${date} / ${time.split(".")[0]}`
    }

    const convertToChartData = (data : AllDaysStatistic):ChartDataRow[] => {
        return data.days.map( el => {
            return {
                date: convertChartDate(el.date),
                campaign: el.statistic.campaignsPercentage,
                inhouseContent: el.statistic.inhouseContentPercentage,
                siteContent: el.statistic.siteContentPercentage,
                other: el.statistic.othersPercentage
            }
        })
    }

    const onStartDateChanged = (date: string) => {
        setSelectedStartDate(date);
    }
    const onEndDateChanged = (date: string) => {
        setSelectedEndDate(date);
    }

    const onTimeChanged = (time: string) => {
        setSelectedTime(time);
    }

    const validateReportPeriodDates = (start: string, end: string) => {
        if(isFirstDateGreaterThanSecond(start, end)){
            setIsSelectedEndDateError(true)
            setIsSelectedStartDateError(true)
        } else {
            setIsSelectedEndDateError(false)
            setIsSelectedStartDateError(false)
        }
    }

    const renderRow = (data: AllDaysStatistic) => {
        return data.days.map( (d,i) => {
            let [date, time] = d.date.split("T")
            return <tr key={`${d.date}-${i}`}>
                <td>
                    {date} / {time.split(".")[0]}
                    {d.isFromHistory ? <p>Historical</p> : null}
                </td>
                <td>{formatDurationLong(d.statistic.campaignsDurationMs)} / {formatToPercent(d.statistic.campaignsPercentage)}</td>
                <td>{formatDurationLong(d.statistic.inhouseContentDurationMs)} / {formatToPercent(d.statistic.inhouseContentPercentage)}</td>
                <td>{formatDurationLong(d.statistic.siteContentDurationMs)} / {formatToPercent(d.statistic.siteContentPercentage)}</td>
                <td>{formatDurationLong(d.statistic.othersDurationMs)} / {formatToPercent(d.statistic.othersPercentage)}</td>
                <td>{formatDurationLong(d.statistic.total)}</td>
            </tr>
        })
    }

    const onSelectedTag = async (newValue: MultiValue<Option<Guid>>) => {
        if(newValue){
            let newTagIds = newValue.map(el => el.value)
            setSelectedTagIds(newTagIds)
        } else {
            setSelectedTagIds([])
        }
    }

    return (  
        <><InnerLayout
            isCollapsed={isCollapsed}
            logOut={logOut}
            toogleCollapse={toogleCollapse}
            activeTab="channels">
                <>
                <div className="d-flex justify-content-between align-items-center pt-20">
                        <h3>Daily SoV</h3>
                        
                </div>
                <div className="" style={{height:500, marginBottom: 40, marginLeft:-33}}>
                    <ResponsiveContainer width="100%" height="100%">
                        <AreaChart
                        width={500}
                        height={400}
                        data={chartData}
                        stackOffset="expand"
                        margin={{
                            top: 10,
                            right: 0,
                            left: 0,
                            bottom: 0,
                        }}
                        >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="date" />
                        <YAxis tickFormatter={formatToPercent} />
                        <Legend />
                        <Area type="monotone" name="Campaign" dataKey="campaign" stackId="1" stroke="#8884d8" fill="#8884d8"  />
                        <Area type="monotone" name="Inhouse Content" dataKey="inhouseContent" stackId="1" stroke="#82ca9d" fill="#82ca9d" />
                        <Area type="monotone" name="Site Content" dataKey="siteContent" stackId="1" stroke="#ffc658" fill="#ffc658" />
                        <Area type="monotone" name="Other" dataKey="other" stackId="1" stroke="#ff0000" fill="#ff0000" />
                        </AreaChart>
                    </ResponsiveContainer>
                </div>

                <div className="">
                    <div className="d-flex gap15 align-items-center">
                        <FormRow>
                            <FormInput
                                errorMessage=""
                                id="playlist_start_date"
                                isError={isSelectedStartDateError}
                                type="date"
                                onChangeValue={(v) => {onStartDateChanged(v)}}
                                value={selectedStartDate}
                                min={getPastDateByDaysAgo(7)}
                                title="Start"
                            />  
                        </FormRow>
                        <FormRow>
                            <FormInput
                                errorMessage=""
                                id="playlist_end_date"
                                isError={isSelectedEndDateError}
                                type="date"
                                onChangeValue={(v) => {onEndDateChanged(v)}}
                                value={selectedEndDate}
                                title="End"
                            />   
                        </FormRow> 
                        <FormRow>
                            <FormInput
                                errorMessage=""
                                id="playlist_time"
                                isError={false}
                                type="time"
                                onChangeValue={(v) => {onTimeChanged(v)}}
                                value={selectedTime}
                                title="Time"
                            />   
                        </FormRow> 

                        <FormRow>
                            <label>Tags Filter</label>
                            <Select 
                                className={`w-100`}
                                options={tags}
                                classNamePrefix={`select`}
                                onChange={onSelectedTag} 
                                isClearable={true}
                                isMulti={true}
                            />
                        </FormRow>

                        <div className="d-flex align-items-center" style={{flex:"0 0 auto", width:"120px"}}>
                            <FormCheckbox id="playlist-checkbox" checked={isLiveToggle} onChange={setIsLiveToggle} />
                            <span className="status-block">
                                {isLiveToggle ? <span className="current-status online">&nbsp;Live</span> : <span className="current-status offline">&nbsp;Scheduled</span>}
                            </span>
                        </div>

                        <Button color="green"  label="Update" onClick={updateList} />
                    </div>

                    {statistic && <table className="table">
                        <thead>
                            <tr>
                                <td>Dates</td>
                                <td>Campaign</td>
                                <td>Inhouse Content</td>
                                <td>Site Content</td>
                                <td>Other</td>
                                <td>Total</td>
                            </tr>
                        </thead>
                        <tbody>
                            {renderRow(statistic)}
                        </tbody>
                    </table>}
                </div>               

                <div className="d-flex justify-content-between align-items-center pt-20">
                    <h3>Playlist View</h3>
                </div>

                <div className="historical">
                    <div className="historical__block">
                        <HistoricViewBlock />
                    </div>
                    <div className="historical__block">
                        <HistoricViewBlock />
                    </div>
                    <div className="historical__block">
                        <HistoricViewBlock />
                    </div>
                </div>
                <GlobalSpinner isShow={isLoading}/>
                </>
        </InnerLayout>
        </>
    );
}
 
export default withRouter(ChannelPlaylist);


